import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { IOlNamesConfig } from 'src/app/models/custom-names.model';
import { ITemplateOfferDetail } from 'src/app/models/templates.model';
import { BeneficioService } from 'src/app/services/pacote-beneficio.service';
import { OlNamesService } from 'src/app/services/ol-names.service';
import { PropostaSalarialService } from 'src/app/services/proposta-salarial.service';
import { SlideBaseComponent } from 'src/app/shared/slider/slide/slide-base.component';
import { formatDayMonthLong } from 'src/app/utils/day-month.utils';
import { getCurrency } from 'src/app/utils/helpers/currency.helper';

@Component({
  selector: 'hr-dynamic-offer-detail',
  templateUrl: './dynamic-offer-detail.component.html',
  styleUrls: ['./dynamic-offer-detail.component.scss'],
  providers: [FormBuilder, OlNamesService],
})
export class DynamicOfferDetailComponent
  extends SlideBaseComponent
  implements OnInit, OnDestroy {
  override initialValue: ITemplateOfferDetail;
  salario: number;
  salaryType: 'horista' | 'mensalista';
  dataAdmissao: string;
  gestor: string;
  hiringBonus: string;
  iLP: string;
  modeloTrabalho: string;
  localTrabalho: string;
  cargaHoraria: string;
  escalaTrabalho: string;
  jornadaTrabalho: string;
  dataBase: string;
  getCurrencyHelper = getCurrency;
  variableWage_1: string;
  variableWage_2: string;
  olNames: IOlNamesConfig;
  grupoSalarialName: string;
  remuneracaoExtra: { title: string; description: string }[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private propostaService: PropostaSalarialService,
    private olNamesService: OlNamesService,
    private beneficioService: BeneficioService
  ) {
    super();
    const proposta = this.propostaService.getView();
    this.salario = proposta.salario;
    this.salaryType = proposta.salaryType;
    this.dataAdmissao = proposta.dataAdmissao.toDate().toLocaleDateString();
    this.gestor = proposta.gestorName;
    this.modeloTrabalho = proposta.modeloTrabalho;
    this.localTrabalho = proposta.localTrabalho;
    this.cargaHoraria = proposta.cargaHoraria;
    this.escalaTrabalho = proposta.escalaTrabalho;
    this.jornadaTrabalho = proposta.jornadaTrabalho;
    this.dataBase = proposta.dataBase ? formatDayMonthLong(proposta.dataBase) : null;
    this.hiringBonus = proposta.hiringBonus ? proposta.hiringBonus : null;
    this.iLP = proposta.iLP ? proposta.iLP : null;
    this.variableWage_1 = this.olNames?.variable_wage_1;
    this.variableWage_2 = this.olNames?.variable_wage_2;
    this.grupoSalarialName = proposta.grupoSalarialName;
  }

  protected onInit(): void {
    this.loadOlNames();
    this.loadRemuneracaoExtra();
  }

  private async loadRemuneracaoExtra() {
    await this.beneficioService.getGrupos();
    this.remuneracaoExtra = (this.beneficioService.remuneracaoBenefits ?? []).map((bene) => ({
      title: bene.name,
      description: bene.description,
    }));
  }


  protected onDestroy(): void { }

  protected initForm(): void {
    this.form = this.formBuilder.group({
      slideName: [null, [Validators.required, Validators.maxLength(20)]],
      title: [null, [Validators.required, Validators.maxLength(40)]],
      wageSubtitle: [null, [Validators.required, Validators.maxLength(40)]],
      variableWage: [null, [Validators.required, Validators.maxLength(20)]],
      variableWageSubtitle: [
        null,
        [Validators.required, Validators.maxLength(40)],
      ],
      secondaryCall: [null, [Validators.required, Validators.maxLength(40)]],
      firstImage: [null],
      firstImageUrl: [null],
      description: [null, [Validators.maxLength(1500)]],
      note: [null, [Validators.required, Validators.maxLength(400)]],
    });
  }

  private async loadOlNames() {
    this.olNames = await this.olNamesService.getOlNames();
  }
}
